export default [
    {
        component: () => import('@/views/Login'),
        meta: {
            redirectHomeIfLogged: true,
            requireAuth: false,
        },
        name: 'Login',
        path: '/',
    },
    {
        component: () => import('@/views/Modules'),
        meta: {
            redirectHomeIfLogged: false,
            requireAuth: true,
            title: 'Módulos',
        },
        name: 'Modules',
        path: '/modules',
    },
    {
        component: () => import('@/views/UserProfile'),
        meta: {
            redirectHomeIfLogged: false,
            requireAuth: true,
            title: 'Informações do usuário',
        },
        name: 'UserProfile',
        path: '/user-profile',
    },
    {
        component: () => import('@/views/ReportGallery'),
        meta: {
            redirectHomeIfLogged: false,
            requireAuth: true,
        },
        name: 'ReportGallery',
        path: '/report-gallery',
    },
    {
        component: () => import('@/views/Report'),
        meta: {
            redirectHomeIfLogged: false,
            requireAuth: true,
        },
        name: 'Report',
        path: '/report',
    },
]
